import { useGetCustomRibbonAuditById } from '@/hooks/queries';

import { getAuditItems } from './auditEntityFinder';
import AuditViewComponent from './AuditViewComponent';
import type { AuditEntityRetrieverInput } from './types';

const CustomRibbonAudit = (input: AuditEntityRetrieverInput) => {
  const { data: result } = useGetCustomRibbonAuditById({
    queryArgs: { id: input.id },
  });
  const { current, previous } = getAuditItems(
    result?.custom_ribbon_audit,
    input.operationDate
  );

  return (
    <AuditViewComponent
      operation={input.operation}
      current={JSON.stringify(current, null, 2)}
      previous={JSON.stringify(previous, null, 2)}
    />
  );
};

export default CustomRibbonAudit;
